import { http } from "./config";

export default {
  // Buscar todas as tarefas
  getAllTasks: () => {
    return http.get("api/v1/task/getall");
  },

  // Buscar tarefa por ID
  getTaskById: (id) => {
    return http.get("api/v1/task/getbyid?id=" + id);
  },

  // Criar nova tarefa
  createTask: (task) => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return http.post("api/v1/task/insert", {
      ...task,
      userId: user.id
    });
  },

  // Atualizar tarefa
  updateTask: (id, task) => {
    return http.post("api/v1/task/update", { id, ...task });
  },

  // Excluir tarefa
  deleteTask: (id) => {
    return http.post("api/v1/task/delete?id=" + id);
  },

  // Buscar tarefas por status
  getTasksByStatus: (status) => {
    return http.get("api/v1/task/getbystatus?status=" + status);
  }
};

